/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgDdosAttack = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.48 5.95H21.99v4h10.49v-4Zm7.37 5.33H21.99v4h17.86v-4ZM56 16.62H12.49v4H56v-4Zm-6.83 5.33H31.99v4h17.18v-4Zm-22.5 0h-9.18v4h9.18v-4Zm17.74 5.33H21.49v4h22.92v-4Zm0 5.34H30.92v4h13.49v-4Zm-22.92 0H8v4h13.49v-4Zm13.99 5.33H8v4h27.48v-4Zm13.69 0h-7.48v4h7.48v-4Zm-9.32 5.33h-7.94v4h7.94v-4Zm-13.59 0h-7.94v4h7.94v-4Zm9.22 5.34H13.43v4h22.05v-4Zm0 5.33H21.04v4h14.44v-4Z"
}));

export default SvgDdosAttack;